export const TOKEN = "ZB4QMUL62BXKNP7NH6UGFPI5VATNUTJ9BPJMHJH9";
export const URL = "https://sigemi.muninqn.gov.ar/apex/rfws/apiweb/";
export const NOW = new Date().toISOString().slice(0, 10);
export const YEAR_NOW = new Date().toISOString().slice(0, 4);
export const MONTH = new Date().toISOString().slice(5, 7);
/* export const TIME_RETURN = 33000;
export const TIME_RETURN_PRINT = 120000; */
export const TIME_PRINT = 4000;
export const TIME_PRINT_CONFIRM = 17000;
export const BACK_RECIBO_ACTA = "https://webservice.muninqn.gov.ar/sistema-multas/api";
